
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oneday",
      function () {
        return require("private-next-pages/oneday.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oneday"])
      });
    }
  